module.exports = __webpack_public_path__ + "static/media/img3.3e006b86.jpg";